import {USER_TYPES} from 'common/constants'
import {getSelectedChildId, setSelectedChildId} from 'common/helpers/selectedChild'
import store from 'setup/redux/Store'

/** Admin/staff/teacher browse the school module under `/institute`. */
export const isInstituteUserType = (userType?: string | null) =>
  [USER_TYPES.ADMIN, USER_TYPES.STAFF, USER_TYPES.TEACHER].includes(userType ?? '')

/**
 * In-app link for a notification's `webUrl`.
 *
 * Students/parents browse legacy pages at un-prefixed front-module paths
 * (e.g. `/homework/view/:id`); only admin/staff/teacher routes live under
 * `/institute` — prefixing for everyone sends students to the school module,
 * which denies them (404 in the iframe).
 */
export const buildNotificationLink = (
  webUrl: string | null | undefined,
  isInstituteUser: boolean
): string => {
  if (!webUrl) return '#'
  const path = webUrl.startsWith('/') ? webUrl : `/${webUrl}`
  if (/^\/(school|institute)(\/|$)/.test(path)) return path
  return isInstituteUser ? `/institute${path}` : path
}

/** Where "View all" / the sidebar entry sends the user for the full inbox. */
export const getNotificationsInboxPath = (isInstituteUser: boolean) =>
  isInstituteUser ? '/institute/notifications/admin' : '/notifications'

/**
 * Follows a notification link. A parent's notification may be about a child
 * other than the one selected, so that child is selected first and the link
 * opened with a full load (child-scoped pages read the selection at mount).
 * @returns true when it navigated with a full load, false for in-app navigation
 */
export const openNotificationLink = (
  link: string,
  studentUserId: number | null | undefined,
  navigate: (to: string) => void
): boolean => {
  if (link === '#') return false
  const children = store.getState().userReducer.user?.children
  if (
    studentUserId &&
    children?.some((child: {id: number}) => child.id === Number(studentUserId)) &&
    getSelectedChildId(children) !== String(studentUserId)
  ) {
    setSelectedChildId(studentUserId)
    window.location.assign(link)
    return true
  }
  navigate(link)
  return false
}
